export const appointmentTypeOptions = [
  { value: "PATIENT", label: "Patient" },
  { value: "MEDICAL_REPRESENTATIVE", label: "Medical Representative" },
];

export const visitTypeOptions = [
  { value: "NEW_CASE", label: "New Case" },
  { value: "OLD_CASE", label: "Old Case" },
  { value: "FOLLOW_UP", label: "Follow Up" },
];

export const visitTypeOptionsMedicalRepresentative = [
  { value: "NEW_VISIT", label: "New Visit" },
  { value: "FOLLOW_UP_VISIT", label: "Follow Up Visit" },
];

export const genderOptions = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
  { value: "OTHER", label: "Other" },
];

export const maritalStatusOptions = [
  { value: "SINGLE", label: "Single" },
  { value: "MARRIED", label: "Married" },
  { value: "DIVORCED", label: "Divorced" },
  { value: "WIDOWED", label: "Widowed" },
  { value: "REMARRIED", label: "Remarried" },
];

export const prefixOptions = [
  { value: "DR", label: "Dr." },
  { value: "MR", label: "Mr." },
  { value: "MS", label: "Ms." },
  { value: "MRS", label: "Mrs." },
  { value: "PROF", label: "Prof." },
];

export const temperatureOptions = [
  { value: "C", label: "°C" },
  { value: "F", label: "°F" },
];

export const temperatureByPalpationOptions = [
  { value: "WARM", label: "Warm" },
  { value: "COOL", label: "Cool" },
  { value: "NORMAL", label: "Normal" },
];

export const SpO2MesurementDefaultOptions = [
  { label: "Right Upper Limb", value: "RIGHT_UPPER_LIMB" },
  { label: "Right Lower Limb", value: "RIGHT_LOWER_LIMB" },
  { label: "Left Upper Limb", value: "LEFT_UPPER_LIMB" },
  { label: "Left Lower Limb", value: "LEFT_LOWER_LIMB" },
];

export const BPMesurementDefaultOptions = [
  { label: "Right Upper Limb", value: "RIGHT_UPPER_LIMB" },
  { label: "Right Lower Limb", value: "RIGHT_LOWER_LIMB" },
  { label: "Left Upper Limb", value: "LEFT_UPPER_LIMB" },
  { label: "Left Lower Limb", value: "LEFT_LOWER_LIMB" },
];

export const ReferredByOptions = [
  { value: "PATIENT", label: "Patient" },
  { value: "ONLINE_SOCIAL_MEDIA", label: "Online or Social Media" },
  { value: "SIGNBOARD", label: "Signboard" },
  { value: "NEWSPAPER", label: "Newspaper" },
  { value: "MEDICAL_CAMP", label: "Medical Camp" },
  { value: "REFERRAL_DOCTOR", label: "Referral Doctor" },
  { value: "SELF", label: "Self" },
  { value: "OTHER", label: "Other" },
];
